module.exports = __webpack_public_path__ + "assets/fengjing.0365fcf7.svg";